import React from 'react';
import { Select, useSelect } from '@econsult/econsult-ui/dist/components/Select';
import _map from 'lodash/map';
import { Option, SelectButton, SelectOptions, Tick } from 'components/Form/Select';
import { ChevronIcon, ErrorIcon } from '@econsult/econsult-ui/dist/assets';
import { InputLabel, InputMessage, InputMessageIcon, InputMessageWrapper, InputWrapper } from '@econsult/econsult-ui/dist/components/Input/InputStyles';
import { StyledFormItemWrapper } from 'components/UserRoleSelect/style';

export const UserRoleSelect = ({ userRoles, userRole, onSelectUserRole, validationMessage }) => {
  const { toggleSelect, selectContext } = useSelect();

  const handleSelectUserRole = role => event => {
    onSelectUserRole(role);
    event.preventDefault();
  };

  return (
    <StyledFormItemWrapper data-automation="FormItemWrapper">
      <InputWrapper data-automation="UserRoleSelect" as="div" state="error">
        <Select closeOnClickOutside selectContext={selectContext} automationName="UserRoleDropdown" theme="light">
          <SelectButton onClick={toggleSelect} type="button" data-automation="UserRoleDropdownButton">
            <span>{userRole?.label || 'Select a user role'}</span> <ChevronIcon />
          </SelectButton>
          <SelectOptions>{_map(userRoles, _option => (
            <Option key={_option.id} onClick={handleSelectUserRole(_option)} data-automation={`UserRole-${_option.id}`}>
              <span>{_option.label}</span>
              <Tick automationName="SelectedUserRoleIndicator" isVisible={userRole?.id === _option.id} />
            </Option>
          ))}
          </SelectOptions>
        </Select>

        <InputLabel data-automation="InputLabel">Practice role</InputLabel>

        {validationMessage && (
          <InputMessageWrapper data-automation="InputMessage">
            <InputMessageIcon><ErrorIcon /></InputMessageIcon>
            <InputMessage>{validationMessage}</InputMessage>
          </InputMessageWrapper>
        )}
      </InputWrapper>
    </StyledFormItemWrapper>
  );
};
